import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReportingService } from '../../reporting-service.service';
import { EngagementActivityVm } from 'app/Models/EngagementActivity';
import { ReportFiltering, ReportMainData } from 'app/ReportingModel/ReportFiltering';
import { SavedReportDto } from 'app/ReportingModel/SavedReportDto';

@Component({
    selector: 'app-booked-time-by-resource-report',
    templateUrl: './booked-time-by-resource-report-component.html',
    styleUrls: ['./booked-time-by-resource-report-component.scss']
})
export class BookedTimeByResourceReportComponent implements OnInit {
    @Input() ReportMainData: ReportMainData;
    constructor(private spinner: NgxSpinnerService,
        private reportService: ReportingService,
    ) { }
    ngOnInit(): void {
        this.spinner.show();
        this.spinner.hide();
    
    }

}
